'use client';

import { __resetStyles, mergeClasses } from "@griffel/react";
import { tokens } from "@fluentui/react-theme";
export const drawerBodyClassNames = {
  root: 'fui-DrawerBody'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__resetStyles("ri6rvx7", null, [".ri6rvx7{padding:0 var(--spacingHorizontalXXL);flex:1;align-self:stretch;position:relative;z-index:1;overflow:auto;}", ".ri6rvx7:last-child{padding-bottom:calc(var(--spacingHorizontalXXL) + 1px);}", ".ri6rvx7:first-child{padding-top:calc(var(--spacingHorizontalXXL) + 1px);}"]);
/**
 * Apply styling to the DrawerBody slots based on the state
 */
export const useDrawerBodyStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(drawerBodyClassNames.root, styles, state.root.className);
  return state;
};